import {
  ChangeDetectionStrategy,
  Component,
  inject,
  AfterContentInit,
  OnDestroy
} from '@angular/core';
import { AdvertiserModule } from '../../advertiser.module';
import { BaseAdvertiserComponent } from '../../abstract-components/base-advertiser.component';
import { PageEvent } from '@angular/material/paginator';
import { filter, tap } from 'rxjs';
import { DialogService } from '~app/app/~shared/services/dialog.service';
import { EventService } from '~app/app/~shared/services/event.service';
import { ResourceFacade } from '~app/app/~store/facades/resource.facade';
import { GlobalEvent } from '~core/models/shared.models';
import { AdvertiserCreationDialogComponent } from '../../modals/advertiser-creation-dialog/advertiser-creation-dialog.component';

@Component({
  selector: 'advertiser-list-page',
  standalone: true,
  imports: [AdvertiserModule],
  templateUrl: './advertiser-list-page.component.html',
  styleUrl: './advertiser-list-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvertiserListPageComponent
  extends BaseAdvertiserComponent
  implements AfterContentInit, OnDestroy
{
  private _dialogService = inject(DialogService);
  private _resourceFacade = inject(ResourceFacade);
  private _eventService = inject(EventService);

  resources$ = this._resourceFacade.resources$;
  currentError$ = this._resourceFacade.currentError$;
  paginationData$ = this._resourceFacade.paginationData$;
  isLoading$ = this._resourceFacade.isLoading$;

  onGlobalRefresh$ = this._eventService.events$.pipe(
    filter((ev: GlobalEvent) => ev.type === 'REFRESH_DATA'),
    tap(() => this.refreshData())
  );

  ngAfterContentInit(): void {
    this._resourceFacade.getData();
  }

  ngOnDestroy(): void {
    this._resourceFacade.resetState();
  }

  refreshData(): void {
    this._resourceFacade.getData({ refresh: true });
  }

  handlePageEvent(e: PageEvent): void {
    this._resourceFacade.setPagination({
      ...(e.pageSize && { itemPerPage: e.pageSize }),
      page: e.pageIndex + 1 || 1
    });
  }

  openAddDialog(): void {
    this._dialogService.open({
      component: AdvertiserCreationDialogComponent,
      fullscreen: true
    });
  }

  onSearch(searchText: string | null): void {
    this._resourceFacade.applyFilters({
      name: searchText ? `like(%${searchText}%)` : null
    });
    this._resourceFacade.getData({ refresh: true });
  }

  onFilterChange(filters: Record<string, unknown>): void {
    this._resourceFacade.applyFilters(filters);
    this._resourceFacade.getData({ refresh: true });
  }
}
